import React from "react";
import "./Background.css";

const Background = () => {
  return (
    <section className="background-section">
      <div className="section-content">
        <h2>Our Background</h2>
        <p>
          We started with a vision to revolutionize the industry by focusing on
          quality, innovation, and customer satisfaction...
        </p>
      </div>
    </section>


  );
};

export default Background;
